
































































































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { ClassCardData } from '../../interfaces/character/classCard';
import ClassCard from './classCard.vue';
import Character from '../../classes/character/character';
import AllCollection from '@/classes/attributes/allCollection';
import { SaveCharacterModifiersPayload } from '@/store/group/types';
import { AttributeExportTypes } from '../../classes/attributes/baseAttribute';
import { Modifier } from '../../classes/character/modifier';
import { type } from 'os';
import { UrangstReason, allUrangste } from '@/classes/character/allValues';
import WeaponAttribute from '../../classes/attributes/weapon';

interface ModifierItem {
  text: string;
  value: string;
  source: string;
  modValue: number;
  valueType: string;
}

@Component({ components: { ClassCard } })
export default class EditCharacterDialog extends Vue {
  @Prop()
  public open!: boolean;

  @Prop()
  public character!: Character;

  private tabModel: number = 0;

  private error: string | null = null;

  private attributeModel: string | undefined = '';
  private attributeValueModel: string | null = null;
  private attributeSaving = false;
  private attributeDiceModel: string | null = null;
  private attributeDiceBonusModel: string | null = null;
  private sourceOfModifierModel: string = '';

  private allCollection = new AllCollection();

  private deletionInProgress = false;
  private deletionIndex = -1;
  private sourceHasError = false;
  private doubtsSaving = false;
  private doubtModels = {
    Urangst: null,
    Panik: null,
    Wut: null,
    Irrsinn: null,
    Vergessen: null,
  };
  private textModel = '';
  private textSaving = false;

  public mounted() {
    for (const reason of this.doubts) {
      const doubt = this.character.getDoubtByReason(reason);
      Vue.set(this.doubtModels, reason, doubt);
    }

    this.textModel = this.character.getCharacterText();
  }

  /**
   * Returns the items for the dropdown consitsting of all available values.
   * If present, exisiting modifiers get their value added
   */
  private getAllValuesWithModifiers(collection: string) {
    const modifierCollection = collection === 'start' ? this.startmodifiers : this.otherModifiers;
    return this.allCollection.allValues
      .sort((valueA, valueB) => (valueA.name < valueB.name ? -1 : 1))
      .map((value) => {
        const category = this.allCollection.getCategoryByAbbreviation(value.abbreviation);
        const modifiers = modifierCollection.filter((mod) => mod.attributeAbbreviation === value.abbreviation);
        let modValue = '';
        let modDiceValue = '';
        let modDiceBonusValue = 0;
        modifiers.forEach((modifier) => {
          switch (modifier.attributeValue) {
            case 'value':
              modValue = modifier.value.toString();
              break;
            case 'numDice':
              modDiceValue = modifier.value.toString();
              break;
            case 'numBonus':
              modDiceBonusValue = modifier.value;
              break;
          }
        });
        let finalModValue = modValue;
        if (modDiceValue !== '' || modDiceBonusValue !== 0) {
          finalModValue = modDiceValue === '' ? '0' : modDiceValue + 'W ';
          finalModValue += modDiceBonusValue < 0 ? modDiceBonusValue : '+' + modDiceBonusValue;
        }

        // Special case: protection elements need their name changed

        return {
          text: value.name,
          value: value.abbreviation,
          category,
          modifier: finalModValue,
          type: value.export().type,
        };
      });
  }

  /**
   * Returns all base modifiers. (source = start)
   */
  get startmodifiers() {
    const startMods = this.character
      .getModifiersBySource('start')
      .sort((modA, modB) => (modA.attributeAbbreviation < modB.attributeAbbreviation ? -1 : 1));

    return startMods;
  }

  get otherModifiers() {
    return this.character
      .getModifiersExcludingSource('start')
      .sort((modA, modB) => (modA.attributeAbbreviation < modB.attributeAbbreviation ? -1 : 1));
  }

  get otherModifierItems(): ModifierItem[] {
    return this.otherModifiers
      .filter((modifier) => modifier.value !== 0)
      .map((modifier) => {
        const name = this.allCollection.getNameByAbbreviation(modifier.attributeAbbreviation);
        const category = this.allCollection.getCategoryByAbbreviation(modifier.attributeAbbreviation);
        return {
          text: name,
          value: modifier.attributeAbbreviation,
          category,
          modifier: modifier.attributeValue === 'numDice' ? modifier.value + 'W' : modifier.value,
          source: modifier.source,
          modValue: modifier.value,
          valueType: modifier.attributeValue,
        };
      });
  }

  get doubts() {
    return [
      UrangstReason.urangst,
      UrangstReason.panik,
      UrangstReason.wut,
      UrangstReason.irrsinn,
      UrangstReason.vergessen,
    ];
  }

  get doubtReasons() {
    const doubtIndex = Object.keys(allUrangste);
    const items: Array<{ text: string; value: string | null }> = [{ text: 'Keine', value: null }];
    for (const doubt of doubtIndex) {
      items.push({ text: allUrangste[doubt], value: doubt });
    }
    return items;
  }

  /**
   * Returns the name of the attribute belonging to this abbreviation.
   * Can optionally be prefixed.
   */
  private getNameByAbbreviation(abbreviation: string, appendix: string = '') {
    let name = this.allCollection.getNameByAbbreviation(abbreviation);

    if (appendix !== '') {
      name += ' ' + appendix;
    }

    return name;
  }

  /**
   * Returns the value of the modifier matching the abbreviation and value type
   * @param abbreviation The abbreviation of the the modifier
   * @param collection Either "start" or anything else
   */
  private getValueOfModifier(abbreviation: string, collection: string, attributeValue = 'value') {
    const modifiers = collection === 'start' ? this.startmodifiers : this.otherModifiers;
    const value = modifiers.find(
      (mod) => mod.attributeAbbreviation === abbreviation && mod.attributeValue === attributeValue,
    )?.value;

    if (typeof value === 'undefined') {
      return 0;
    } else {
      return value;
    }
  }

  get isSimpleType() {
    const modifierType = this.allCollection.allValues
      .find((value) => value.abbreviation === this.attributeModel)
      ?.export().type;
    return (
      modifierType === AttributeExportTypes.Resource ||
      modifierType === AttributeExportTypes.Talent ||
      modifierType === AttributeExportTypes.Attribute
    );
  }

  /**
   * saving one or two new modifiers
   */
  private onSaveAttributeClick(isBaseModifier = true) {
    this.error = null;

    const modifiers: Modifier[] = [];
    if (typeof this.attributeModel === 'undefined') {
      throw new Error('No attribute selected');
    }

    if (!isBaseModifier && this.sourceOfModifierModel === '') {
      this.sourceHasError = true;
      return;
    }
    this.sourceHasError = false;

    // Simple types have only one value
    if (this.isSimpleType) {
      if (this.attributeValueModel === null) {
        throw new Error('New Value is not set');
      }
      modifiers.push({
        attributeAbbreviation: this.attributeModel,
        attributeValue: 'value',
        source: isBaseModifier ? 'start' : this.sourceOfModifierModel,
        value: parseInt(this.attributeValueModel, 10),
      });

      // Complex types have 2
    } else {
      if (this.attributeDiceModel === null && this.attributeDiceBonusModel === null) {
        throw new Error('Dice and bonus is not set');
      }
      if (this.attributeDiceModel !== null) {
        const diceValue = parseInt(this.attributeDiceModel, 10);
        if (diceValue !== 0) {
          modifiers.push({
            attributeAbbreviation: this.attributeModel,
            attributeValue: 'numDice',
            source: isBaseModifier ? 'start' : this.sourceOfModifierModel,
            value: diceValue,
          });
        }
      }
      if (this.attributeDiceBonusModel !== null) {
        const diceBonusValue = parseInt(this.attributeDiceBonusModel, 10);
        if (diceBonusValue !== 0) {
          modifiers.push({
            attributeAbbreviation: this.attributeModel,
            attributeValue: 'numBonus',
            source: isBaseModifier ? 'start' : this.sourceOfModifierModel,
            value: diceBonusValue,
          });
        }
      }
    }

    const characterId = this.character.getCharacterId();
    if (characterId === null) {
      throw new Error('Character has no ID');
    }

    // Get modifiers and replace or add the one
    const allMods = this.character.getModifiers();

    for (const modifier of modifiers) {
      // Run adding / replacing once for each
      const index = allMods.findIndex(
        (mod) =>
          mod.source === modifier.source &&
          mod.attributeAbbreviation === modifier.attributeAbbreviation &&
          mod.attributeValue === modifier.attributeValue,
      );
      if (index > -1) {
        allMods[index].value = modifier.value;
      } else {
        allMods.push(modifier);
      }
    }

    this.attributeSaving = true;
    const payload: SaveCharacterModifiersPayload = {
      characterId,
      modifiers: allMods,
    };
    this.$store
      .dispatch('saveCharacterModifiers', payload)
      .then(() => {
        this.attributeModel = undefined;
        this.attributeValueModel = null;
        this.attributeDiceModel = null;
        this.attributeDiceBonusModel = null;
        this.sourceOfModifierModel = '';
      })
      .catch((error) => {
        this.error = error;
      })
      .finally(() => {
        this.attributeSaving = false;
      });
  }

  private onChangeAttribute(collection: string) {
    // Clear all corresponding models
    this.attributeValueModel = null;
    this.attributeDiceModel = null;
    this.attributeDiceBonusModel = null;
    this.sourceOfModifierModel = '';

    if (typeof this.attributeModel === 'undefined') {
      return;
    }

    if (collection !== 'start') {
      return;
    }

    if (this.isSimpleType) {
      const value = this.getValueOfModifier(this.attributeModel, collection);
      if (value !== null) {
        this.attributeValueModel = value.toString();
      }
    } else {
      const diceValue = this.getValueOfModifier(this.attributeModel, collection, 'numDice');
      if (diceValue !== null) {
        this.attributeDiceModel = diceValue.toString();
      }
      const bonusValue = this.getValueOfModifier(this.attributeModel, collection, 'numBonus');
      if (bonusValue !== null) {
        this.attributeDiceBonusModel = bonusValue.toString();
      }
    }
  }

  private onRemoveModifierClick(modifier: ModifierItem, index: number) {
    // Get modifiers and replace or add the one
    let allMods = this.character.getModifiers();

    // Find this specific modifier
    const modifierIndex = allMods.findIndex((localMod) => {
      return (
        localMod.attributeAbbreviation === modifier.value &&
        localMod.attributeValue === modifier.valueType &&
        localMod.value === modifier.modValue &&
        localMod.source === modifier.source
      );
    });

    if (modifierIndex < 0) {
      throw new Error('Did not find index for mod ' + modifier.source + ' ' + modifier.value + ' index ' + index);
    }

    this.deletionInProgress = true;
    this.deletionIndex = index;

    // break reference
    allMods = JSON.parse(JSON.stringify(allMods));

    // Remove modifier at this index
    allMods.splice(modifierIndex, 1);

    const characterId = this.character.getCharacterId();
    if (characterId === null) {
      throw new Error('Character has no ID');
    }

    const payload: SaveCharacterModifiersPayload = {
      characterId,
      modifiers: allMods,
    };
    this.$store
      .dispatch('saveCharacterModifiers', payload)
      .catch((error) => {
        this.error = error;
      })
      .finally(() => {
        this.deletionIndex = -1;
        this.deletionInProgress = false;
      });
  }

  private onEditModifierClick(modifier: ModifierItem) {
    this.attributeModel = modifier.value;
    this.sourceOfModifierModel = modifier.source;

    // First reset all models
    this.attributeValueModel = null;
    this.attributeDiceModel = null;
    this.attributeDiceBonusModel = null;

    switch (modifier.valueType) {
      case 'value':
        this.attributeValueModel = modifier.modValue.toString();
        break;

      case 'numDice':
        this.attributeDiceModel = modifier.modValue.toString();
        break;

      case 'numBonus':
        this.attributeDiceBonusModel = modifier.modValue.toString();
        break;

      default:
        throw new Error('Unexpected attributeValue: ' + modifier.valueType);
    }
  }

  private onSaveDoubtsClick() {
    const payload = {
      characterId: this.character.getCharacterId(),
      doubts: this.doubtModels,
    };
    this.doubtsSaving = true;
    this.$store.dispatch('updateCharacterDoubts', payload).then(() => {
      this.doubtsSaving = false;
    });
  }

  private onSaveTextClick() {
    const payload = {
      characterId: this.character.getCharacterId(),
      miscText: this.textModel,
    };
    this.textSaving = true;
    this.$store.dispatch('updateCharacterText', payload).then(() => {
      this.textSaving = false;
    });
  }
}
